'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').provider('onboardingRouter', onboardingRouterProvider);

  onboardingRouterProvider.$inject = ['authenticationRouterProvider'];

  // Onboarding router helpers for code reuse
  var helpers = {
    resolveSsoOrganization: function resolveSsoOrganization() {
      // Gets organization from currentSsoInfo
      return ['authenticationSvc', function (authenticationSvc) {
        var currentSsoInfo = authenticationSvc.getCurrentSsoInfo();
        var noOrgError = { errorCode: 'NO_ORG' };
        if (_.isUndefined(currentSsoInfo) || _.isUndefined(currentSsoInfo.attributesView)) {
          return noOrgError;
        }
        // Return noOrgError if org cannot be set by currentSsoInfo
        return authenticationSvc.getOrganizationBySsoIdp(currentSsoInfo.attributesView.idpId, currentSsoInfo.attributesView.accessCode).then(function (resp) {
          var organization;
          if (resp.data) {
            organization = resp.data;
          }
          return organization;
        }, function () {
          return noOrgError;
        });
      }];
    }
  };

  /* @ngInject */
  function onboardingRouterProvider(authenticationRouterProvider) {
    var provider = this;
    provider.buildSignUpRoutes = _buildSignUpRoutes;
    provider.buildLoginRoutes = _buildLoginRoutes;
    provider.configure = _configure;

    provider.$get = ['$log', '$state', '$sessionStorage', 'errorRouter', 'authenticationRouter', onboardingRouterFactory];

    function onboardingRouterFactory($log, $state, $sessionStorage, errorRouter, authenticationRouter) {
      var factory = this,
          featureVisibility = {
        0: true, //Account
        1: false, //Mood
        2: false, //Assessment
        3: false //Customization
      };
      factory.router = {
        getFeatureVisibility: _getFeatureVisibility,
        getContext: _getContext,
        ssoMapLoginError: _ssoMapLoginError,
        navigateSsoLogin: _navigateSsoLogin,
        navigateSsoLanding: _navigateSsoLanding,
        navigateSsoCustomLanding: _navigateSsoCustomLanding,
        navigateSsoEmail: _navigateSsoEmail,
        navigateSsoUniqueEmail: _navigateSsoUniqueEmail,
        navigateSsoExisting: _navigateSsoExisting,
        navigateSsoAgeError: _navigateSsoAgeError,
        navigateSsoError: _navigateSsoError,
        navigateRedirect: _navigateRedirect,
        navigateSleepSchedule: _navigateSleepSchedule,
        navigateMfaAuthCode: _navigateMfaAuthCode,
        goToState: authenticationRouter.goToState,
        goToNextStep: authenticationRouter.goToNextStep,
        getRequirement: authenticationRouter.getRequirement,
        markRequirementComplete: authenticationRouter.markRequirementComplete,
        clearRequirements: authenticationRouter.clearRequirements,
        navigateError: errorRouter.navigateError,
        navigate404: errorRouter.navigate404,
        removeLoginStep: authenticationRouter.removeLoginStep
      };
      return factory.router;

      function _getContext() {
        return authenticationRouterProvider.context;
      }

      function _getFeatureVisibility() {
        if ($sessionStorage.authRequirements) {
          $sessionStorage.authRequirements.forEach(function (req) {
            $log.debug(req);
            if (req.requirementType === 'TRACKER') {
              featureVisibility['1'] = true;
            } else if (req.requirementType === 'ASSESSMENT') {
              featureVisibility['2'] = true;
            } else if (req.requirementType === 'PERSONALIZATION') {
              featureVisibility['3'] = true;
            }
          });
        }
        $log.debug('fetching featureVisibility - ' + JSON.stringify(featureVisibility));
        return featureVisibility;
      }

      function _navigateSleepSchedule(args) {
        authenticationRouter.goToState('sleep.schedule', args);
      }

      function _navigateRedirect(args) {
        authenticationRouter.goToState('redirect', args);
      }

      function _navigateSsoLogin(args) {
        authenticationRouter.goToState('sso.login', args);
      }

      function _navigateSsoLanding(args) {
        authenticationRouter.goToState('sso.landing', args);
      }

      function _navigateSsoCustomLanding(args) {
        authenticationRouter.goToState('sso.customLanding', args);
      }

      function _navigateSsoEmail(args) {
        authenticationRouter.goToState('sso.email', args);
      }

      function _navigateCustomSsoEmail(args) {
        authenticationRouter.goToState('sso.customemail', args);
      }

      function _navigateSsoUniqueEmail(args) {
        authenticationRouter.goToState('sso.uniqueEmail', args);
      }

      function _navigateCustomSsoUniqueEmail(args) {
        authenticationRouter.goToState('sso.customUniqueEmail', args);
      }

      function _navigateSsoUniqueIdentifierCollision(args) {
        authenticationRouter.goToState('sso.uniqueIdentifierCollision', args);
      }

      function _navigateSsoExisting(args) {
        authenticationRouter.goToState('sso.existing', args);
      }

      function _navigateCustomSsoExisting(args) {
        authenticationRouter.goToState('sso.customExisting', args);
      }

      function _navigateSsoAgeError(args) {
        authenticationRouter.goToState('error.age', args);
      }

      function _navigateSsoError(args) {
        authenticationRouter.goToState('error.sso', args);
      }

      function _navigateMfaAuthCode(args) {
        authenticationRouter.goToState('authcode', args);
      }

      function _ssoMapLoginError(err, organization) {
        var errorNavMap = {
          INVALID_EMAIL_ADDRESS: _navigateSsoEmail,
          AGE_RESTRICTION: _navigateSsoAgeError,
          USER_ALREADY_EXISTS: _navigateSsoExisting,
          UNIQUE_EMAIL_ADDRESS_REQUIRED: _navigateSsoUniqueEmail,
          SSO_UNIQUE_IDENTIFIER_COLLISION: _navigateSsoUniqueIdentifierCollision
        };

        if (err.data && err.data.errorCode && errorNavMap.hasOwnProperty(err.data.errorCode)) {
          if (organization && organization.shortName === 'BSC' && (err.data.errorCode === 'INVALID_EMAIL_ADDRESS' || err.data.errorCode === 'UNIQUE_EMAIL_ADDRESS_REQUIRED' || err.data.errorCode === 'USER_ALREADY_EXISTS')) {
            if (err.data.errorCode === 'INVALID_EMAIL_ADDRESS') {
              _navigateCustomSsoEmail();
            } else if (err.data.errorCode === 'USER_ALREADY_EXISTS') {
              _navigateCustomSsoExisting();
            } else {
              _navigateCustomSsoUniqueEmail();
            }
          } else {
            errorNavMap[err.data.errorCode]({ error: err.data });
          }
        } else {
          _navigateSsoError({
            contact: true
          });
        }
      }
    }

    function _configure(context) {
      authenticationRouterProvider.configure(context);
    }

    function _buildDoneRoute() {
      return {
        name: 'done',
        url: '/done?redirecturl&isMobileWebView&mobilePlatform',
        controller: 'DoneCtrl',
        controllerAs: 'vm',
        resolve: {
          providerPreferences: ['providerSvc', function (providerSvc) {
            return providerSvc.getPreferences();
          }],
          user: ['userSvc', function (userSvc) {
            return userSvc.getUser();
          }]
        }
      };
    }

    function _buildLegacyRoute() {
      return {
        name: 'legacy',
        url: '/legacy',
        onEnter: ['$log', '$stateParams', 'windowSvc', 'domainSvc', 'userSvc', 'onboardingRouter', function ($log, $stateParams, windowSvc, domainSvc, userSvc, onboardingRouter) {
          var user = userSvc.getUser();
          if (!user.vNextEnabled) {
            onboardingRouter.clearRequirements();
            $log.debug('Sending user to legacy sign-in URL with stateParams', $stateParams);
            windowSvc.windowNavigate(domainSvc.getSigninUrl($stateParams));
          } else {
            //move on if the user isn't a legacy user
            onboardingRouter.goToNextStep();
          }
        }]
      };
    }

    function _buildRedirectRoute() {
      return {
        name: 'redirect',
        url: '/redirect?redirecturl',
        onEnter: ['$log', '$stateParams', 'windowSvc', 'domainSvc', 'onboardingRouter', function ($log, $stateParams, windowSvc, domainSvc, onboardingRouter) {
          //checks for relative path redirects
          var isRelativeRedirect = $stateParams.redirecturl && _.startsWith($stateParams.redirecturl, '/');
          //check for fully qualified redirects in our domains (admin, provider connect, etc.)
          var isMyStrengthRedirect = $stateParams.redirecturl && _.includes($stateParams.redirecturl, domainSvc.getRootDomain());
          if (isRelativeRedirect || isMyStrengthRedirect) {
            $log.debug('Sending user to approved redirect URL ', $stateParams.redirecturl);
            onboardingRouter.clearRequirements();
            windowSvc.windowNavigate($stateParams.redirecturl);
          } else {
            //move on if there isn't a redirect into our app
            onboardingRouter.goToNextStep();
          }
        }]
      };
    }

    function _buildHomepageRoute() {
      return {
        name: 'home',
        url: '/home',
        onEnter: ['$log', '$stateParams', '$sessionStorage', 'onboardingRouter', 'windowSvc', 'domainSvc', 'authenticationSvc', 'user', function ($log, $stateParams, $sessionStorage, onboardingRouter, windowSvc, domainSvc, authenticationSvc, user) {
          onboardingRouter.clearRequirements();
          var sessionStoreRedirectUrl = $sessionStorage.redirectUrl;
          // Follow redirectUrl from session storage first
          if (sessionStoreRedirectUrl) {
            delete $sessionStorage.redirectUrl;
            onboardingRouter.navigateRedirect({
              redirecturl: authenticationSvc.getFullyQualifiedRedirectUrl(sessionStoreRedirectUrl)
            });
          } else if ($stateParams.redirecturl) {
            onboardingRouter.navigateRedirect({
              redirecturl: authenticationSvc.getFullyQualifiedRedirectUrl($stateParams.redirecturl)
            });
          }
          var preferences = user.providerPreferences;
          if (preferences && preferences.defaultDestinationUri) {
            var url = domainSvc.getRelativeUrl(preferences.defaultDestinationUri);
            $log.debug('Sending user to alternate homepage - ' + url);
            windowSvc.windowNavigate(url);
          } else if (user.accessCode && user.accessCode.type === 'YOUTH') {
            $log.debug('Sending user to Youth homepage');
            windowSvc.windowNavigate('/y/');
          } else {
            $log.debug('Sending user to vNext homepage');
            windowSvc.windowNavigate('/v/');
          }
        }],
        resolve: {
          user: ['userSvc', function (userSvc) {
            return userSvc.getUser();
          }]
        },
        params: {
          redirecturl: {
            value: null,
            squash: true
          }
        }
      };
    }

    function _buildInterventionRoute() {
      return {
        name: 'intervention',
        url: '/int',
        params: {
          redirecturl: {
            value: null,
            squash: true
          }
        },
        onEnter: ['$stateParams', '$log', 'onboardingRouter', 'windowSvc', function ($stateParams, $log, onboardingRouter, windowSvc) {
          var requirement = onboardingRouter.getRequirement('TRACKER_INTERVENTION'),
              interventionTag = _.get(requirement, 'data.tags[0].shortName');

          if (!requirement || !interventionTag) {
            if (requirement) {
              //mark it complete - it was configured poorly on the server
              onboardingRouter.markRequirementComplete('intervention');
            }
            //move on if there isn't a redirect into our app
            onboardingRouter.goToNextStep();
          } else {
            var id = requirement.data.id;
            var tagId = encodeURIComponent(interventionTag);
            var redirecturl = $stateParams.redirecturl;
            var url = '/v/int?sliderId=' + id + '&tag=' + tagId;

            if (redirecturl && redirecturl.length > 0) {
              url = url + ('&redirecturl=' + redirecturl);
            }

            $log.debug('Sending user to vNext tracker interventions page - ' + url);
            onboardingRouter.clearRequirements();
            windowSvc.windowNavigate(url);
          }
        }]
      };
    }

    function _buildTrainRoute() {
      return {
        name: 'train',
        url: '/train',
        onEnter: ['$log', 'onboardingRouter', 'windowSvc', function ($log, onboardingRouter, windowSvc) {
          if (!onboardingRouter.getRequirement('SHOW_TRAIN')) {
            //move on if there isn't a redirect into our app
            onboardingRouter.goToNextStep();
          } else {
            var url = '/v/train';
            $log.debug('Sending user to vNext activity train page - ' + url);
            windowSvc.windowNavigate(url);
          }
        }]
      };
    }

    function _buildCommunityGuidelinesRoute() {
      return {
        name: 'steps.communityGuidelines',
        url: 'communityGuidelines',
        templateUrl: 'onboarding/pages/communityGuidelines.html',
        controller: 'GuidelinesCtrl',
        controllerAs: 'vm',
        resolve: {
          isLoggedIn: ['msAuth', function (msAuth) {
            return msAuth.isLoggedIn();
          }]
        },
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        }
      };
    }

    function _buildCustomAgreementRoute() {
      return {
        name: 'steps.agreements',
        url: 'agreements',
        templateUrl: 'onboarding/pages/agreements.html',
        controller: 'agreementsCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: 'pageTitles.agreements'
        },
        resolve: {
          user: ['userSvc', function (userSvc) {
            return userSvc.getUser().then(function (user) {
              return user;
            });
          }],
          isSkipFeatureEnabled: ['providerSvc', function (providerSvc) {
            return providerSvc.isFeatureEnabled('SSO_SKIP_TERMS_AND_CONDITIONS').then(function (isEnabled) {
              return isEnabled;
            });
          }]
        }
      };
    }

    function _buildCustomTermsOfUseRoute() {
      return {
        name: 'steps.terms',
        url: 'terms',
        templateUrl: 'onboarding/pages/providerTermsOfUse.html',
        controller: 'ProviderTermsOfUseCtrl',
        data: {
          noAuth: true
        }
      };
    }

    function _buildCustomTermsOfUseAfterRoute() {
      return {
        name: 'steps.termsAfter',
        url: 'termsa',
        templateUrl: 'onboarding/pages/providerTermsOfUse.html',
        controller: 'ProviderTermsOfUseCtrl'
      };
    }

    function _buildWelcomeEntryRoute() {
      // welcome must be last to avoid it globbing onto the other states
      return {
        name: 'welcome',
        url: '/:organization/:group?pc&ref&isMobileWebView&mobilePlatform',
        templateUrl: 'onboarding/pages/welcome.html',
        controller: 'WelcomeCtrl',
        data: {
          pageTitle: 'pageTitles.signup',
          noAuth: true
        },
        // this is required for IE8 to work!
        params: {
          organization: {
            value: null,
            squash: true
          },
          group: {
            value: null,
            squash: true
          },
          pc: {
            value: null
          },
          ref: {
            value: null
          }
        },
        onEnter: ['msAuth', 'windowSvc', 'domainSvc', function (msAuth, windowSvc, domainSvc) {
          if (msAuth.isLoggedIn()) {
            windowSvc.windowNavigate(domainSvc.getRelativeUrl('/login'));
          }
        }]
      };
    }

    function _buildStepsBaseRoute() {
      return {
        name: 'steps',
        abstract: true,
        url: '/?isMobileWebView&mobilePlatform&isSubjectToGDPR',
        template: '<div class="onboarding-wrapper">\n                     <ms-onboarding-header ms-only-onboarding></ms-onboarding-header>\n                      <div class="ani-wrapper">\n                       <ui-view class="step-view"></ui-view>\n                      </div>\n                    </div>'
      };
    }

    function _buildPersonalizationRoute() {
      return {
        name: 'steps.customization',
        url: 'customization',
        data: {
          pageTitle: 'pageTitles.personalization'
        },
        resolve: {
          $components: ['MetadataSvc', function (MetadataSvc) {
            return MetadataSvc.fetchProfileComponents();
          }],
          $user: ['$state', 'userSvc', function ($state, userSvc) {
            return userSvc.getUser().then(function (user) {
              return user;
            }, function () {
              $state.go('error', {
                message: 'A networking error occurred'
              });
            });
          }]
        },
        controller: ['$scope', '$stateParams', 'onboardingRouter', '$components', '$user', function ($scope, $stateParams, onboardingRouter, $components, $user) {
          $scope.components = $components;
          $scope.user = $user;
          //pass in the nextStep fn
          $scope.goToNextStep = function () {
            onboardingRouter.goToNextStep($stateParams);
          };
        }],
        templateUrl: 'onboarding/pages/customization.html'
      };
    }

    function _buildThanksRoute() {
      return {
        name: 'steps.thanks',
        url: 'thanks',
        resolve: {
          programs: ['surveySvc', '$log', function (surveySvc, $log) {
            return surveySvc.getUserPrograms().then(function (resp) {
              $log.debug('thanks resp data: ', resp.data);
              return resp;
            });
          }]
        },
        template: '<thanks programs="$resolve.programs"/>',
        data: {
          pageTitle: 'pageTitles.default'
        }
      };
    }

    function _buildAccountRoute() {
      return {
        name: 'steps.account',
        url: 'account?oauthTicket',
        templateUrl: 'onboarding/pages/account.html',
        controller: 'AccountCtrl',
        data: {
          pageTitle: 'pageTitles.accountSetup',
          noAuth: true
        },
        onEnter: ['msAuth', 'windowSvc', 'domainSvc', function (msAuth, windowSvc, domainSvc) {
          if (msAuth.isLoggedIn()) {
            windowSvc.windowNavigate(domainSvc.getRelativeUrl('/login'));
          }
        }]
      };
    }

    function _buildSurveyRoute() {
      return {
        name: 'steps.survey',
        url: 'survey',
        template: '<div data-ms-survey data-context="onboarding"></div>'
      };
    }

    function _buildTrackerRoute() {
      return {
        name: 'steps.mood',
        url: 'mood',
        data: {
          pageTitle: 'pageTitles.mood'
        },
        templateUrl: 'onboarding/pages/mood.html',
        controller: 'OnboardingMoodCtrl',
        controllerAs: 'vm',
        resolve: {
          providerPreferences: ['providerSvc', function (providerSvc) {
            return providerSvc.getPreferences().then(function (prefs) {
              return prefs;
            });
          }],
          moodTrackers: ['moodTrackerSvc', 'languageSvc', '$translate', 'onboardingRouter', 'userSvc', function (moodTrackerSvc, languageSvc, $translate, onboardingRouter, userSvc) {
            var context = onboardingRouter.getContext();
            return $translate.use(languageSvc.getLanguage()).then(function () {
              return userSvc.getUser().then(function (user) {
                if (context === 'onboarding' || !user.isProfileComplete) {
                  return moodTrackerSvc.getOnboardingMoods();
                } else {
                  return moodTrackerSvc.getTrackedMoods();
                }
              });
            });
          }]
        }
      };
    }

    function _buildSleepBaseRoute() {
      return {
        name: 'sleep',
        abstract: true,
        default: '.diary',
        data: {
          pageTitle: 'pageTitles.sleepCalendar'
        },
        templateUrl: 'onboarding/pages/sleepBase.html',
        url: '/sleep'
      };
    }

    function _buildSleepDiaryRoute() {
      return {
        name: 'sleep.calendar',
        url: '/calendar',
        templateUrl: 'onboarding/pages/sleep-calendar-page.html',
        controller: 'SleepCalendarCtrl',
        controllerAs: 'vm'
      };
    }

    function _buildSleepDiaryEntryRoute() {
      return {
        name: 'sleep.entry',
        url: '/entry?day',
        templateUrl: 'sleep/pages/sleep-entry.html',
        params: {
          day: null
        },
        controller: ['$stateParams', 'onboardingRouter', 'eventTrackingSvc', function ($stateParams, onboardingRouter, eventTrackingSvc) {
          this.showCalendarOverlay = false;
          this.day = $stateParams.day;
          this.isOnboardingRoute = true;
          this.onUpdateDay = function (day) {
            onboardingRouter.goToState('^.entry', {
              day: day
            });
          };

          this.entryComplete = function (data) {
            eventTrackingSvc.fireEvent('sleepTool', 'diaryEntry', onboardingRouter.getContext());
            onboardingRouter.goToState('^.entry-summary', {
              day: $stateParams.day,
              entryData: data.entryData,
              requirements: data.requirements
            });
          };
        }],
        /** Load the route after all translations are ready */
        resolve: {
          translationReady: ['$translate', function ($translate) {
            return $translate.onReady(function () {
              return $translate('common.time.hour').then(function (res) {
                return res;
              });
            });
          }]
        },
        controllerAs: 'vm'
      };
    }

    function _buildSleepDiaryEntryDoneRoute() {
      return {
        name: 'sleep.entry-summary',
        url: '/entry/summary?day',
        templateUrl: 'sleep/pages/sleep-entry-summary.html',
        controller: 'SleepEntryDoneCtrl',
        controllerAs: 'vm',
        params: {
          day: null,
          entryData: null,
          requirements: null
        }
      };
    }

    function _buildInitialSleepScheduleRoute() {
      return {
        name: 'sleep.schedule-initial',
        url: '/schedule_check',
        templateUrl: 'onboarding/pages/sleep-schedule-checkin-page.html',
        controller: ['$log', 'schedule', 'onboardingRouter', function ($log, schedule, onboardingRouter) {
          var _this = this;

          this.$onInit = function () {
            $log.debug('Initial Sleep Schedule onInit');
            _this.schedule = schedule;
          };

          this.continue = function () {
            onboardingRouter.goToNextStep({}, {
              name: 'onboarding.mood.overlay'
            });
          };
        }],
        controllerAs: 'vm',
        params: {
          schedule: null
        },
        resolve: {
          schedule: ['sleepScheduleSvc', '$log', function (sleepScheduleSvc, $log) {
            return sleepScheduleSvc.getSchedule().then(function (schedule) {
              $log.debug('sleep schedule retrieved {}', schedule);
              return schedule;
            });
          }]
        }
      };
    }

    function _buildSleepNeedsRoute() {
      return {
        name: 'sleep.needs',
        url: '/needs?cid',
        templateUrl: 'onboarding/pages/sleep-needs-page.html',
        controller: 'SleepNeedsCtrl',
        controllerAs: 'vm'
      };
    }

    function _buildSleepScheduleRoute() {
      return {
        name: 'sleep.schedule',
        url: '/schedule?cid',
        templateUrl: 'onboarding/pages/sleep-schedule-page.html',
        controller: 'SleepScheduleCtrl',
        controllerAs: 'vm'
      };
    }

    function _buildSleepPlanRoute() {
      return {
        name: 'sleep.plan',
        url: '/plan?cid',
        templateUrl: 'onboarding/pages/sleep-plan-page.html',
        controller: 'SleepPlanCtrl',
        controllerAs: 'vm'
      };
    }

    function _buildRequestPasswordResetRoute() {
      return {
        name: 'reset',
        url: '/reset?locked&isMobileWebView&mobilePlatform',
        templateUrl: 'onboarding/pages/request-reset-password.html',
        controller: 'requestResetPasswordCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        }
      };
    }

    function _buildPasswordChangeRoute() {
      return {
        name: 'password',
        url: '/password?token&isPasswordExpiration',
        templateUrl: 'onboarding/pages/change-password.html',
        controller: 'ChangePasswordCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        params: {
          isPasswordExpiration: {
            squash: true
          }
        },
        onEnter: ['$stateParams', 'msAuth', function ($stateParams, msAuth) {
          if ($stateParams.token) {
            msAuth.setToken($stateParams.token);
          }
          msAuth.partialLogout();
        }]
      };
    }

    function _buildMfaAuthCodeRoute() {
      return {
        name: 'authcode',
        url: '/authcode?redirecturl',
        templateUrl: 'onboarding/pages/authcodecard.html',
        controller: 'MfaAuthCodeCtrl',
        controllerAs: 'vm',
        params: {
          redirecturl: {
            value: null,
            squash: true
          }
        }
      };
    }

    function _buildNoAccessRoute() {
      return {
        name: 'noaccess',
        url: '/noaccess',
        templateUrl: 'onboarding/pages/noaccess.html',
        controller: 'NoAccessCtrl',
        controllerAs: 'vm'
      };
    }

    function _buildLoginRoute() {
      return {
        name: 'login',
        url: '/:organization?prg&ownerId&redirecturl&mfa&isMobileWebView&mobilePlatform',
        templateUrl: 'onboarding/pages/logincard.html',
        controller: 'LoginCtrl',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.login'
        },
        params: {
          organization: {
            value: null,
            squash: true
          },
          redirecturl: {
            value: null,
            squash: true
          },
          prg: {
            value: null,
            squash: true
          },
          ownerId: {
            value: null,
            squash: true
          },
          isMobileWebView: {
            value: null,
            squash: true
          },
          mobilePlatform: {
            value: null,
            squash: true
          }
        }
      };
    }

    function _buildSsoBaseRoute() {
      return {
        name: 'sso',
        abstract: true,
        templateUrl: 'onboarding/pages/ssoBase.html',
        url: '/sso'
      };
    }

    function _buildSsoCustomDataRoute() {
      return {
        name: 'sso.customData',
        url: '?tokenid&agentid&isTest&samlSsoAttributesId&keycloakToken',
        templateUrl: 'onboarding/pages/custom-data.html',
        controller: 'CustomDataCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          isSso: true,
          pageTitle: 'pageTitles.default'
        },
        resolve: {
          ssoAuthView: ['onboardingRouter', '$stateParams', '$rootScope', 'authenticationSvc', 'msAuth', function (onboardingRouter, $stateParams, $rootScope, authenticationSvc, msAuth) {
            // TODO: Find possibility to prevent ERROR on language change
            if ($rootScope.isSsoAttributesExists && authenticationSvc.getCurrentSsoInfo()) {
              return authenticationSvc.getCurrentSsoInfo();
            }

            msAuth.clearCookieToken();
            msAuth.clearLocalStorage();
            msAuth.clearSessionStorage();

            if ($stateParams.samlSsoAttributesId) {
              return authenticationSvc.loadTeladocSsoAuthInfo($stateParams.samlSsoAttributesId, $stateParams.isTest).then(function (data) {
                $rootScope.isSsoAttributesExists = true;
                return data;
              }, function () {
                onboardingRouter.navigateSsoError({
                  contact: true
                });
              });
            } else if ($stateParams.keycloakToken) {
              return authenticationSvc.loadKeycloakSsoAuthInfo($stateParams.keycloakToken).then(function (data) {
                $rootScope.isSsoAttributesExists = true;
                return data;
              }, function () {
                onboardingRouter.navigateSsoError({
                  contact: true
                });
              });
            } else {
              return authenticationSvc.loadSsoAuthInfo($stateParams.tokenid, $stateParams.agentid, $stateParams.isTest).then(function (data) {
                return data;
              }, function () {
                onboardingRouter.navigateSsoError({
                  contact: true
                });
              });
            }
          }],
          translationReady: ['$translate', function ($translate) {
            return $translate.onReady(function () {
              return $translate('login.sso.landing.title').then(function (res) {
                return res;
              });
            });
          }]
        }
      };
    }

    function _buildSsoLoginRoute() {
      return {
        name: 'sso.login',
        url: '/go?tokenid&agentid&isTest&samlSsoAttributesId',
        controller: 'SsoCtrl',
        controllerAs: 'vm',
        resolve: {
          ssoAuthView: ['onboardingRouter', '$stateParams', 'authenticationSvc', function (onboardingRouter, $stateParams, authenticationSvc) {
            if ($stateParams.samlSsoAttributesId) {
              return authenticationSvc.loadTeladocSsoAuthInfo($stateParams.samlSsoAttributesId, $stateParams.isTest).then(function (data) {
                return data;
              }, function () {
                onboardingRouter.navigateSsoError({
                  contact: true
                });
              });
            } else {
              return authenticationSvc.loadSsoAuthInfo($stateParams.tokenid, $stateParams.agentid, $stateParams.isTest).then(function (data) {
                return data;
              }, function () {
                onboardingRouter.navigateSsoError({
                  contact: true
                });
              });
            }
          }]
        },
        data: {
          noAuth: true
        },
        // this is required for IE8 to work!
        params: {
          tokenid: {
            value: null,
            squash: false
          },
          agentid: {
            value: null,
            squash: false
          },
          isTest: {
            value: null,
            squash: false
          },
          mergeDisabled: {
            value: false,
            squash: true
          }
        }
      };
    }

    function _buildSsoEmailRoute() {
      return {
        name: 'sso.email',
        url: '/email',
        templateUrl: 'onboarding/pages/ssoEmailRequired.html',
        controller: 'SsoEmailCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        params: {
          error: {
            value: null,
            squash: true
          }
        },
        resolve: {
          ssoAuthView: ['authenticationSvc', function (authenticationSvc) {
            return authenticationSvc.getCurrentSsoInfo();
          }],
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoCustomEmailRoute() {
      return {
        name: 'sso.customemail',
        url: '/custom-email',
        templateUrl: 'onboarding/pages/ssoCustomEmailRequired.html',
        controller: 'SsoEmailCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        params: {
          error: {
            value: null,
            squash: true
          }
        },
        resolve: {
          ssoAuthView: ['authenticationSvc', function (authenticationSvc) {
            return authenticationSvc.getCurrentSsoInfo();
          }],
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoUniqueEmailRoute() {
      return {
        name: 'sso.uniqueEmail',
        url: '/unique-email',
        templateUrl: 'onboarding/pages/ssoUniqueEmailRequired.html',
        controller: 'SsoEmailCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        params: {
          error: {
            value: null,
            squash: true
          }
        },
        resolve: {
          ssoAuthView: ['authenticationSvc', function (authenticationSvc) {
            return authenticationSvc.getCurrentSsoInfo();
          }],
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoCustomUniqueEmailRoute() {
      return {
        name: 'sso.customUniqueEmail',
        url: '/custom-unique-email',
        templateUrl: 'onboarding/pages/ssoCustomUniqueEmailRequired.html',
        controller: 'SsoEmailCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        params: {
          error: {
            value: null,
            squash: true
          }
        },
        resolve: {
          ssoAuthView: ['authenticationSvc', function (authenticationSvc) {
            return authenticationSvc.getCurrentSsoInfo();
          }],
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoUniqueIdentifierCollisionRoute() {
      return {
        name: 'sso.uniqueIdentifierCollision',
        url: '/unique-identifier-conflict',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        onEnter: ['onboardingRouter', '$translate', function (onboardingRouter, $translate) {
          $translate.onReady(function () {
            $translate('login.sso.uniqueIdentifierCollision').then(function (msg) {
              onboardingRouter.navigateError({
                message: msg
              });
            });
          });
        }]
      };
    }

    function _buildSsoPasswordRoute() {
      return {
        name: 'sso.password',
        url: '/password',
        templateUrl: 'onboarding/pages/ssoPassword.html',
        controller: 'SsoPasswordCtrl',
        controllerAs: 'vm',
        resolve: {
          organization: helpers.resolveSsoOrganization()
        },
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        }
      };
    }

    function _buildSsoReturnRoute() {
      return {
        name: 'sso.return',
        url: '/return?email&idpid&ac&uid&mid&incid&token&redirecturl',
        controller: 'SsoReturnCtrl',
        controllerAs: 'vm',
        resolve: {
          ssoIdView: ['$stateParams', function ($stateParams) {
            return {
              idpId: $stateParams.idpid,
              incentivesId: $stateParams.incid ? $stateParams.incid : null,
              email: $stateParams.email,
              ticket: $stateParams.token,
              accessCode: $stateParams.ac,
              uniqueId: $stateParams.mid || $stateParams.uid,
              redirectUrl: $stateParams.redirecturl
            };
          }]
        },
        data: {
          noAuth: true
        },
        params: {
          email: {
            value: null,
            squash: true
          },
          idpid: {
            value: null,
            squash: true
          },
          ac: {
            value: null,
            squash: true
          },
          uid: {
            value: null,
            squash: true
          },
          mid: {
            value: null,
            squash: true
          },
          token: {
            value: null,
            squash: true
          },
          redirecturl: {
            value: null,
            squash: true
          }
        }
      };
    }

    function _buildSsoExistingRoute() {
      return {
        name: 'sso.existing',
        url: '/existing',
        templateUrl: 'onboarding/pages/ssoExisting.html',
        controller: 'SsoExistingCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        resolve: {
          ssoAuthView: ['authenticationSvc', function (authenticationSvc) {
            return authenticationSvc.getCurrentSsoInfo();
          }],
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoCustomExistingRoute() {
      return {
        name: 'sso.customExisting',
        url: '/custom-existing',
        templateUrl: 'onboarding/pages/ssoCustomExisting.html',
        controller: 'SsoExistingCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        resolve: {
          ssoAuthView: ['authenticationSvc', function (authenticationSvc) {
            return authenticationSvc.getCurrentSsoInfo();
          }],
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoLandingRoute() {
      return {
        name: 'sso.landing',
        url: '/landing',
        templateUrl: 'onboarding/pages/ssoLanding.html',
        controller: 'SsoLandingCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        resolve: {
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoKeycloakLandingRoute() {
      return {
        name: 'sso.keycloak',
        url: '/keycloak',
        templateUrl: 'onboarding/pages/ssoKeycloakLanding.html',
        controller: 'SsoKeycloakLandingCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        }
      };
    }

    function _buildSsoCustomLandingRoute() {
      return {
        name: 'sso.customLanding',
        url: '/custom-landing',
        templateUrl: 'onboarding/pages/ssoCustomLanding.html',
        controller: 'SsoLandingCtrl',
        controllerAs: 'vm',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        resolve: {
          organization: helpers.resolveSsoOrganization()
        }
      };
    }

    function _buildSsoErrorRoute() {
      return {
        name: 'error.sso',
        url: '/sso',
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.default'
        },
        onEnter: ['onboardingRouter', '$translate', function (onboardingRouter, $translate) {
          $translate('login.sso.error').then(function (msg) {
            onboardingRouter.navigateError({
              message: msg,
              contact: true
            });
          });
        }]
      };
    }

    function _buildSsoErrorAgeRoute() {
      return {
        name: 'error.age',
        url: '/sso',
        data: {
          noAuth: true
        },
        onEnter: ['onboardingRouter', '$translate', function (onboardingRouter, $translate) {
          $translate('login.sso.error').then(function (msg) {
            onboardingRouter.navigateError({
              message: msg,
              contact: true
            });
          });
        }]
      };
    }

    function _buildSignUpRoutes() {
      var done = _buildDoneRoute();
      var legacy = _buildLegacyRoute();
      var homepage = _buildHomepageRoute();
      var intervention = _buildInterventionRoute();
      var redirect = _buildRedirectRoute();
      var steps = _buildStepsBaseRoute();
      var communityGuidelines = _buildCommunityGuidelinesRoute();
      var terms = _buildCustomTermsOfUseRoute();
      var agreements = _buildCustomAgreementRoute();
      var termsAfter = _buildCustomTermsOfUseAfterRoute();
      var account = _buildAccountRoute();
      var survey = _buildSurveyRoute();
      var tracker = _buildTrackerRoute();
      var personalization = _buildPersonalizationRoute();
      var thanks = _buildThanksRoute();
      var train = _buildTrainRoute();

      //this must go last to ensure correct query string and route globbing
      var welcome = _buildWelcomeEntryRoute();

      var signupRoutes = [done, legacy, redirect, intervention, homepage, terms, agreements, account, termsAfter, steps, communityGuidelines, survey, tracker, personalization, thanks, train, welcome];

      // If the route does not have a template, give it an empty <span>.
      // When no template defined,
      // the pre-angular bootstrap content in the main <ui-view> in onboarding.html will be rendered.
      signupRoutes.forEach(function (r) {
        if (!r.hasOwnProperty('template') && !r.hasOwnProperty('templateUrl')) {
          r.template = '<span></span>';
        }
      });
      //the welcome route needs to be last in the array for globbing
      return signupRoutes;
    }

    function _buildLoginRoutes() {
      //get the possible sign-up resume routes
      var done = _buildDoneRoute();
      var legacy = _buildLegacyRoute();
      var homepage = _buildHomepageRoute();
      var redirect = _buildRedirectRoute();
      var intervention = _buildInterventionRoute();
      var steps = _buildStepsBaseRoute();
      var communityGuidelines = _buildCommunityGuidelinesRoute();
      var terms = _buildCustomTermsOfUseRoute();
      var agreements = _buildCustomAgreementRoute();
      var termsAfter = _buildCustomTermsOfUseAfterRoute();
      var account = _buildAccountRoute();
      var survey = _buildSurveyRoute();
      var tracker = _buildTrackerRoute();
      //get the sleep routes
      var sleepBase = _buildSleepBaseRoute();
      var sleepDiary = _buildSleepDiaryRoute();
      var sleepDiaryEntry = _buildSleepDiaryEntryRoute();
      var sleepDiaryEntryDone = _buildSleepDiaryEntryDoneRoute();
      var initialSleepSchedule = _buildInitialSleepScheduleRoute();
      var sleepNeeds = _buildSleepNeedsRoute();
      var sleepSchedule = _buildSleepScheduleRoute();
      var sleepPlan = _buildSleepPlanRoute();
      var train = _buildTrainRoute();
      var personalization = _buildPersonalizationRoute();
      var thanks = _buildThanksRoute();
      //get the SSO routes
      var ssoError = _buildSsoErrorRoute();
      var ssoAgeError = _buildSsoErrorAgeRoute();
      var ssoBase = _buildSsoBaseRoute();
      var ssoCustomData = _buildSsoCustomDataRoute();
      var ssoLogin = _buildSsoLoginRoute();
      var ssoEmail = _buildSsoEmailRoute();
      var ssoCustomEmail = _buildSsoCustomEmailRoute();
      var ssoUniqueEmail = _buildSsoUniqueEmailRoute();
      var ssoCustomUniqueEmail = _buildSsoCustomUniqueEmailRoute();
      var ssoUniqueIdentifierCollision = _buildSsoUniqueIdentifierCollisionRoute();
      var ssoPassword = _buildSsoPasswordRoute();
      var ssoReturn = _buildSsoReturnRoute();
      var ssoExisting = _buildSsoExistingRoute();
      var ssoCustomExisting = _buildSsoCustomExistingRoute();
      var ssoLanding = _buildSsoLandingRoute();
      var ssoCustomLanding = _buildSsoCustomLandingRoute();
      var ssoCKeycloakLanding = _buildSsoKeycloakLandingRoute();
      //get the login routes
      var mfaAuthCodeRoute = _buildMfaAuthCodeRoute();
      var loginRoute = _buildLoginRoute();
      var requestResetRoute = _buildRequestPasswordResetRoute();
      var passwordChangeRoute = _buildPasswordChangeRoute();
      var noAccessRoute = _buildNoAccessRoute();

      //the login route needs to be last in the array for globbing
      return [ssoError, ssoAgeError, done, legacy, redirect, intervention, homepage, terms, agreements, account, termsAfter, steps, communityGuidelines, survey, tracker, sleepBase, sleepDiary, sleepDiaryEntry, sleepDiaryEntryDone, initialSleepSchedule, sleepNeeds, sleepSchedule, sleepPlan, personalization, thanks, train, requestResetRoute, passwordChangeRoute, ssoBase, ssoCustomData, ssoLogin, ssoPassword, ssoEmail, ssoCustomEmail, ssoUniqueEmail, ssoCustomUniqueEmail, ssoUniqueIdentifierCollision, ssoExisting, ssoCustomExisting, ssoReturn, ssoLanding, ssoCustomLanding, ssoCKeycloakLanding, mfaAuthCodeRoute, noAccessRoute, loginRoute];
    }
  }
})();